import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const autoExpandSelectionRangeOnInlineNodePluginKey: PluginKey = new PluginKey(
	'autoExpandSelectionRangeOnInlineNodePlugin',
);
